import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntEmptyDividerModule, IntSortIconModule} from "../../components";
import {IntTableSortingComponent} from "./int-table-sorting.component";

@NgModule({
  imports: [
    CommonModule,
    IntSortIconModule,
    IntEmptyDividerModule
  ],
  declarations: [
    IntTableSortingComponent
  ],
  exports: [
    IntTableSortingComponent
  ]
})
export class IntTableSortingModule {}
